export const API_FIXED_VENTA_DEVOLUCION_TOTAL_URL =
  // "http://127.0.0.1:5001/fixeddesarrollo-8b589/southamerica-east1/apiFixed/ventaDevolucionTotalCrear";
  "https://southamerica-east1-fixedtesting-10ce2.cloudfunctions.net/apiFixed/ventaDevolucionTotalCrear";

export interface ApiFixedVentaDevolucionTotalCrearRequest {
  apiKey: string;
  rutComercio: string;
  idCFE: string;
  fecha: string;
  cotizacion: number;
  ordenCompra: string;
  local: string;
  adenda: string;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type ApiFixedVentaDevolucionTotalCrearResponse = any;

export const ventaDevolucionTotalCrear = async (
  payload: ApiFixedVentaDevolucionTotalCrearRequest
): Promise<ApiFixedVentaDevolucionTotalCrearResponse> => {
  const res = await fetch(API_FIXED_VENTA_DEVOLUCION_TOTAL_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(payload)
  });

  const contentType = res.headers.get("content-type") ?? "";
  const out =
    contentType.includes("application/json") || contentType.includes("json")
      ? await res.json().catch(() => null)
      : await res.text().catch(() => null);

  if (!res.ok) {
    throw new Error(out.descripcion);
  }

  return out;
};
